import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20cinematic%20movie%20theater%20atmosphere%20with%20dramatic%20warm%20red%20and%20gold%20spotlight%20effects%2C%20abstract%20film%20texture%20background%2C%20luxurious%20theater%20curtains%2C%20epic%20scale%2C%20cinematic%20ambiance%2C%20rich%20dark%20tones%20with%20warm%20accents&width=1920&height=800&seq=hero-bg-main&orientation=landscape"
          alt="91影视看片app"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-background-50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500/20 backdrop-blur-sm rounded-full mb-6">
          <i className="ri-fire-line text-primary-400 text-sm"></i>
          <span className="text-primary-300 text-sm font-medium">每日更新 · 全网热门影视一网打尽</span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 font-heading leading-tight max-w-3xl">
          最新电影在线看 · 热门电视剧全集
          <br />
          <span className="text-primary-400">综艺节目在线播放</span>
        </h1>
        <p className="text-foreground-300 text-base md:text-lg max-w-2xl mb-8 leading-relaxed">
          影视排行榜实时更新，追剧看片一站式搞定，高清流畅不缓冲，热门内容一网打尽。每日更新最新电影、热播剧集、热门综艺，畅享极致观影体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/movie"
            className="px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观影
          </Link>
          <Link
            to="/category/tv"
            className="px-8 py-3 bg-background-100/80 backdrop-blur-sm text-foreground-800 font-semibold rounded-full hover:bg-background-200 transition-all duration-300 border border-background-300/60 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-tv-line mr-2"></i>
            热门剧集
          </Link>
        </div>

        {/* Stats */}
        <div className="flex items-center gap-6 md:gap-10 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">10万+</p>
            <p className="text-foreground-400 text-xs mt-1">影视资源</p>
          </div>
          <div className="w-px h-10 bg-background-300/60"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">5000万+</p>
            <p className="text-foreground-400 text-xs mt-1">注册用户</p>
          </div>
          <div className="w-px h-10 bg-background-300/60"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日更新</p>
            <p className="text-foreground-400 text-xs mt-1">影视内容</p>
          </div>
        </div>
      </div>
    </section>
  );
}